import Edge_Px from './Images1/Edge_px.png';
import Punarvi from './Images1/Punarvi.png';
import WOG from './Images1/WOG.png';
import Value_vin from './Images1/Value_vin.png';
import VitHub from './Images1/VitHub.png';
import ivoice from './Images1/ivoice.png';

const Portfolio_Data = [
    {
        id:1,
        company_name:"Edge PX",
        company_logo:Edge_Px,
    },
    {
        id:2,
        company_name:"Purnarvi Designers",
        company_logo:Punarvi
    },
    {
        id:3,
        company_name:"Value Vin Shree",
        company_logo:Value_vin
    },
    {
        id:4,
        company_name:'Wall of Gardens',
        company_logo:WOG
    },
    {
        id:5,
        company_name:"VIJAYAWADA INNOVATIVE TECHNOLOGY DEVELOPMENT HUB PRIVATE LIMITED",
        company_logo:VitHub,
    },
    {
        id:6,
        company_name:"I-VOICE RESEARCH & CONSULTANCY PRIVATE LIMITED",
        company_logo:ivoice,
    }

];
export default Portfolio_Data;